import React, { useState, useEffect, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import urls from "../../../constants";
import { CurrencyConvertion, FormatValueDecimal } from "../../../utils/Validate";

const ExampleCustomInput = forwardRef(({ value, onClick, disabled }, ref) => (
    <input
        value={value}
        className="requested-delivery-date-input"
        onClick={onClick}
        ref={ref}
        placeholder="DD/MM/YYYY"
        readOnly
        disabled={disabled}
    />
));

const TableRow = ({
    currencyDetail,
    productitem,
    productindex,
    variantsArray,
    productConfigVariant,
    commentOpen,
    setCommentOpen,
    onProductChange,
    onItemDeliveryDateChange,
    onNotesChange,
    values,
    factoryOrderRecord,
    releaseForm,
    isFactoryOrderEdit,
    isFactoryOrderReleased
}) => {
    const list = variantsArray?.filter(d => d?.sid === productitem?.sid) ?? [];
    const isInCurrentOrder = productitem?.isInCurrentOrder !== false;
    const factoryOrderProduct = factoryOrderRecord?.products?.find(
        p => String(p?.customerOrderProductId) === String(productitem?.orderProductId ?? productitem?.quoteProductId ?? productitem?.id)
    );
    const factoryOrderItem = factoryOrderProduct?.productItems?.find(item =>
        String(
            item?.customerOrderProductItemId ??
            item?.quoteProductItemId ??
            item?.orderProductItemId ??
            item?.id
        ) === String(productitem?.id ?? productitem?.quoteProductItemId ?? productitem?.orderProductItemId)
    );

    const visibleColumns = (productConfigVariant || [])
        .filter(v => !urls?.HIDDEN_FIELDS_GROUP?.includes(v?.groupId))
        .sort((a, b) => (a?.sequence ?? 0) - (b?.sequence ?? 0));

    const isNegativeMargin = Number(productitem?.margin || 0) < 0;

    const quoteQty = Number(productitem?.qtyValues ?? productitem?.quoteQuantity ?? 0);

    const customerOrderQty = Number(productitem?.lpoQuantity ?? 0);

    const releasedQty = Number(productitem?.releasedQuantity ?? 0);
    const releasedLimitQty = Number(
        factoryOrderItem?.currentReleaseQuantity ??
        factoryOrderItem?.factoryReleasedQuantity ??
        productitem?.releasedQuantity ??
        productitem?.factoryReleasedQuantity ??
        0
    );
const currentReleasedQty = Number(
    productitem?.currentReleasedQuantity ??
    Math.max(Number(customerOrderQty) - Number(releasedQty), 0)
);

    const getDateValue = (value, fallback) => {
        const dateValue = value || fallback;
        if (!dateValue) return null;
        const date = new Date(dateValue);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    const [
        editableCurrentReleasedQty,
        setEditableCurrentReleasedQty
    ] = useState(currentReleasedQty);

    useEffect(() => {
        setEditableCurrentReleasedQty(currentReleasedQty);
    }, [
        productitem?.sid,
        productitem?.lpoQuantity,
        productitem?.isInCurrentOrder,
        productitem?.currentReleasedQuantity,
        productitem?.factoryReleasedQuantity,
        productitem?.releasedQuantity,
        currentReleasedQty
    ]);

    const [rowErrorMsg, setRowErrorMsg] = useState("");

    const handleClearError = () => {
        if (rowErrorMsg) setRowErrorMsg("");
    };

const handleCurrentReleasedChange = (e) => {
    const enteredValue = e.target.value;

    if (!isInCurrentOrder) {
        setEditableCurrentReleasedQty(0);
        setRowErrorMsg("");
        return;
    }

    if (enteredValue === "") {
        setEditableCurrentReleasedQty("");
        setRowErrorMsg("");
        onProductChange(e, productitem);
        return;
    }

    const numericValue = Number(enteredValue);

    if (Number.isNaN(numericValue)) {
        return;
    }

    const lpoQty = Number(productitem?.lpoQuantity ?? 0);
    const availableQty = isFactoryOrderReleased
        ? Math.max(releasedLimitQty, 0)
        : Math.max(lpoQty, 0);

    if (numericValue > availableQty) {
        setRowErrorMsg(
            isFactoryOrderReleased
                ? `Released factory order quantity cannot be greater than ${availableQty}.`
                : `Factory order quantity has only ${availableQty} quantity available.`
        );
        return;
    }

    setEditableCurrentReleasedQty(enteredValue);
    setRowErrorMsg("");

    onProductChange(e, productitem);
};
    return (
        <tr className={isNegativeMargin ? "negative-margin-row" : ""}>
            {visibleColumns.map((colVariant, varindex) => {
                const match = list.find(d => d?.variantId === colVariant?.variantId);
                return (
                    <td key={colVariant?.variantId ?? varindex}>
                        {varindex === 0 ? (
                            <div className="custom-checkbox custom-checkbox-blue d-flex justify-content-center">
                                {productindex + 1}
                            </div>
                        ) : (match?.variantValue || "")}
                    </td>
                );
            })}

            <td>
                {FormatValueDecimal(
                    CurrencyConvertion(
                        Number(productitem?.listPriceValues) || 0,
                        Number(values?.conversionRate) || 1,
                        currencyDetail?.shortCode
                    )
                )}
            </td>
            <td>{productitem?.lpoQuantity || "0"}</td>
<td>{factoryOrderItem?.factoryReleasedQuantity ?? productitem?.releasedQuantity ?? 0}</td>
            {/* <td>{isFactoryOrderEdit ? (factoryOrderItem?.currentReleaseQuantity ?? factoryOrderItem?.factoryReleasedQuantity ?? 0) : (productitem?.releasedQuantity ?? 0)}</td> */}
            <td className="lpo-qty-cell">
                <input
                className={`form-control${rowErrorMsg ? " input-error" : ""}`}
                name="currentReleasedQuantity"
                type="number"
                min="0"
                max={isInCurrentOrder ? (isFactoryOrderReleased ? releasedLimitQty : Number(productitem?.lpoQuantity ?? 0)) || undefined : 0}
                value={editableCurrentReleasedQty}
                disabled={!isInCurrentOrder || isFactoryOrderReleased}
                onFocus={handleClearError}
                onClick={handleClearError}
                onChange={handleCurrentReleasedChange}
            />
                {rowErrorMsg && (
                    <span className="field-error-tooltip">
                        {rowErrorMsg}
                    </span>
                )}
            </td>
            <td>{Number(productitem?.margin || 0).toFixed(2)}</td>
            <td>
                {FormatValueDecimal(
                        Number(productitem?.totalPrice) || 0
                        )}
            </td>
            <td>
                <div className="notes-cell"  title={productitem?.notes}>
                    {productitem?.notes}
                </div>
            </td>
            <td>
               <DatePicker
                    selected={getDateValue(
                        productitem?.requestedDeliveryDate ??
                        productitem?.effectiveRequestedDeliveryDate ??
                        factoryOrderItem?.requestedDeliveryDate ??
                        factoryOrderItem?.effectiveRequestedDeliveryDate,
                        releaseForm?.deliveryFromDate ?? releaseForm?.scheduledDeliveryDate ?? values?.scheduledDeliveryDate
                    )}
                    onChange={(date) => onItemDeliveryDateChange && onItemDeliveryDateChange(date, productitem)}
                    customInput={<ExampleCustomInput disabled={!isInCurrentOrder || isFactoryOrderReleased} />}
                    dateFormat="dd/MM/yyyy"
                    disabled={!isInCurrentOrder || isFactoryOrderReleased}
                />
            </td>
        </tr>
    );
};

export default TableRow
